import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { Col, Table, Row, Divider, Alert } from 'antd';
import { ExcelIcon } from 'icons';
import Filters from 'components/filters';
import useFootfalls from '../useFootfalls';
import UIHelper from 'helpers/UIHelper';

const MainPage = () => {
  const {
    columns,
    data,
    loading,
    onChangeTableFilter,
    filters,
    handleDownloadExcel,
  } = useFootfalls(true);

  return (
    <>
      <PageHeader title={'FOOTFALL DEL VILLAGE'}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              Esporta
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Alert
          message={
            '* Necessario selezionare filtro outlet village per visualizzare i fatturati correttamente'
          }
          type='warning'
        />
        <br />
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={UIHelper.assignTire(columns)}
          dataSource={data.footfalls}
          pagination={data.pagination}
          scroll={{ x: 1000 }}
          onChange={onChangeTableFilter}
          loading={loading}
        />
      </div>
    </>
  );
};

export default MainPage;
